if (!customElements.get('complementary-product-slider')) {
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        var slideCount = this.querySelectorAll('.swiper-slide').length;
        var hasMultiple = slideCount > 1;

        var nav = this.querySelector('.fc-complementary-nav');
        if (nav) {
          if (hasMultiple) {
            nav.classList.remove('fc-complementary-nav--hidden');
          } else {
            nav.classList.add('fc-complementary-nav--hidden');
          }
        }

        this.sliderOptions = {
          slidesPerView: '1',
          spaceBetween: 10,
          loop: hasMultiple,
          grabCursor: false,
          allowTouchMove: hasMultiple,
          autoHeight: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
        };

        const slider = this.querySelector('.swiper');
        this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
